import React from 'react'

function Feature() {
  return (
    <div className="border-[1px]">
    <div className="border-b-[1px] h-[50px] flex items-center px-[10px] font-semibold text-[20px]">
      <h>Diamond Feature</h>
    </div>
    <div className='py-[120px] px-[20px] flex justify-center'>
      <span className='font-fair text-[RED] text-[14px] text-center'>YOU ARE NOT ELIGIBLE FOR ACCESS THIS FEATURE.PLEASE TAKE DIAMOND PACKAGE PLAN</span>
    </div>
  </div>
  )
}

export default Feature
